import module from 'nominas/nomina/module.js'
import template from './template.html'
import { orderBy } from 'lodash'
import * as moment from 'moment'

export class NominasNominaDispersionPagosPagarConfirmarComponent {
  admin
  idProyecto
  idNomina
  idTipoPago
  idMetodoPago
  idMoneda
  data
  omitidos
  onClose
  chequeNumeroRepetir = false
  chequeNumero = null
  error = null
  incluyeDolares = false
  solicitarChequeFolio = false
  loaded = false
  cuentasBancarias = []
  cuentaBancaria = undefined
  promise = null
  noCancelables
  notas

  constructor ($filter, $q, NominasNominaInformacionFechapago, NominasNominaDispersionPagosPagados, NominaOperadoraCuentasbancarias) {
    this.$filter = $filter
    this.$q = $q
    this.NominasNominaInformacionFechapago = NominasNominaInformacionFechapago
    this.NominasNominaDispersionPagosPagados = NominasNominaDispersionPagosPagados
    this.NominaOperadoraCuentasbancarias = NominaOperadoraCuentasbancarias
  }

  $onInit () {
    this.incluyeDolares = this.idMoneda !== 1
    this.solicitarChequeFolio = this.idMetodoPago === 2

    this.promise = this.$q.all([
        this.NominasNominaInformacionFechapago.get(this.idProyecto, this.idNomina)
          .then(({data}) => (this.fechaPago = data.fecha_pago)),
        this.NominaOperadoraCuentasbancarias.get(this.idProyecto, this.idNomina)
          .then(({data}) => {
            this.cuentasBancarias = orderBy(data, ['moneda', 'banco', 'cuenta'])
            this.cuentaBancaria = this.cuentasBancarias.find((item) => item.predeterminado)
          }),
      ])
      .then(() => {
        this.loaded = true

        this.validar()
      })
      .catch((a) => console.log(a))
  }

  $onChanges (changes) {
    if (changes.data) {
      this.data = [...this.data]
      this.noCancelables = this.data.some((item) => !item.cancelable)

      this.tipoCambio = this.data.reduce((tipoCambio, pago) => {
        if (tipoCambio === null || (tipoCambio !== undefined && tipoCambio !== pago.tipo_cambio)) {
          return null
        } else {
          return pago.tipo_cambio
        }
      }, undefined)

      this.totalizar()
    }
  }

  aceptar () {
    if (this.actualizando) return

    this.data.forEach((item, index) => {
      const numeroCheque = (this.solicitarChequeFolio && this.chequeNumero)
        ? (this.chequeNumero + (this.chequeNumeroRepetir ? 0 : index))
        : null

      item.id_cuenta_retiro = this.cuentaBancaria.id_cuenta
      item.cheque_numero = numeroCheque
      item.fecha_pago = this.fechaPago
      item.motivo = this.notas
      item.status_pagado = true
    })

    let data = this.data.map((item) => ({
      id: item.id,
      beneficiario_id_empleado: item.beneficiario_id_empleado,
      beneficiario_id_empresa: item.beneficiario_id_empresa,
      cancelable: item.cancelable,
      cheque_numero: item.cheque_numero,
      colaborador: item.colaborador,
      fecha_pago: item.fecha_pago,
      id_cuenta_retiro: item.id_cuenta_retiro,
      id_empleado: item.id_empleado,
      id_empresa: item.id_empresa,
      id_metodo_pago: item.id_metodo_pago,
      id_moneda: item.id_moneda,
      importe: item.importe,
      indice: item.indice,
      motivo: item.motivo,
      tipo_cambio: item.tipo_cambio,
    }))

    this.actualizando = true
    this.error = null

    this.NominasNominaDispersionPagosPagados.post(this.idProyecto, this.idNomina, this.idTipoPago, data)
      .then(() => {
        this.data.forEach((item) => {
          item.cuenta_retiro = `${this.cuentaBancaria.banco} ${this.cuentaBancaria.cuenta} ${this.cuentaBancaria.moneda}`
        })

        this.onClose({$event: {data: this.data}})
      })
      .catch(({data}) => (this.error = data))
      .finally(() => (this.actualizando = false))
  }

  cancelar () {
    this.onClose({$event: {data: null}})
  }

  validar () {
    this.alerta = null

    if (!this.fechaPago) return

    const hoy = new Date()
    const diffDays = Math.ceil((this.fechaPago.getTime() - hoy.getTime()) / (1000 * 3600 * 24))

    if (diffDays < -60 || diffDays > 5) {
      const dias = Math.abs(diffDays)
      const mayorMenor = diffDays > 0 ? 'mayor' : 'menor'
      const fechaActual = moment(hoy).format('DD/MM/YYYY')
      this.alerta = `La fecha de pago es ${dias} días ${mayorMenor} a la fecha actual ${fechaActual}`
    }
  }

  modificarTipoCambio () {
    this.data.forEach((item) => (item.tipo_cambio = this.tipoCambio))

    this.totalizar()
  }

  totalizar () {
    this.total = +this.data.reduce((total, item) => total + (item.importe / item.tipo_cambio), 0).toFixed(2)
  }
}

module.component('nominasNominaDispersionPagosPagarConfirmar', {
  controller: NominasNominaDispersionPagosPagarConfirmarComponent,
  template,
  bindings: {
    admin: '<',
    idProyecto: '<',
    idNomina: '<',
    idTipoPago: '<',
    idMetodoPago: '<',
    idMoneda: '<',
    data: '<',
    omitidos: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/pagar/confirmar/component.js